import { render, staticRenderFns } from "./Servicos.vue?vue&type=template&id=79cf9785&"
import script from "./Servicos.vue?vue&type=script&lang=js&"
export * from "./Servicos.vue?vue&type=script&lang=js&"
import style0 from "./Servicos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports